/**
 * Valores de la renta de la persona del AT 2026 (año comercial 2025). Cambian cada año:
 * otro año tiene su propio archivo. Fuente: instrucciones oficiales del F22 AT 2026 del SII
 * (https://www.sii.cl/servicios_online/renta/2026/archivos/l<N>_instruccion.pdf).
 */

// Unidades al 31-12-2025 (líneas 9, 24, 25, 41 y 54)
const UTA_DICIEMBRE = 834504;
const UTM_DICIEMBRE = 69542;
const UF_31_DICIEMBRE = 39727.96;

// Línea 24: la base hasta 13,5 UTA está exenta del IGC
const BASE_EXENTA_IGC = 11265804;

// Línea 25: tabla del IGC (art. 52 LIR), según la Circular N° 5 de 2026
const TABLA_IGC = [
  { hasta: 11265804, factor: 0, rebaja: 0 },
  { hasta: 25035120, factor: 0.04, rebaja: 450632.16 },
  { hasta: 41725200, factor: 0.08, rebaja: 1452036.96 },
  { hasta: 58415280, factor: 0.135, rebaja: 3746922.96 },
  { hasta: 75105360, factor: 0.23, rebaja: 9296374.56 },
  { hasta: 100140480, factor: 0.304, rebaja: 14854171.2 },
  { hasta: 258696240, factor: 0.35, rebaja: 19460633.28 },
  { hasta: Infinity, factor: 0.4, rebaja: 32395445.28 },
];

// Línea 29: restitución del 35 % de los créditos sujetos a restitución
const TASA_RESTITUCION = 0.35;

// Línea 41: crédito por gastos en educación, 4,4 UF por hijo; rentas hasta 792 UF
const UF_POR_HIJO_EDUCACION = 4.4;
const TOPE_RENTAS_EDUCACION_UF = 792;

module.exports = {
  UTA_DICIEMBRE,
  UTM_DICIEMBRE,
  UF_31_DICIEMBRE,
  BASE_EXENTA_IGC,
  TABLA_IGC,
  TASA_RESTITUCION,
  UF_POR_HIJO_EDUCACION,
  TOPE_RENTAS_EDUCACION_UF,
};
